var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagTnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13090_62974",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13090_62974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4293 14.8693L20.2375 15.9294L18.2448 13.2184L18.2621 16.5782L15.0703 17.6383L18.2737 18.6578L18.2911 22.0234L20.2549 19.2892L23.4583 20.3145L21.4655 17.6035L23.4293 14.8693Z",
    fill: "url(#paint0_linear_13090_62974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.74609 0V34.9942H43.7481V0H-8.74609ZM17.501 27.7648C11.8299 27.7648 7.2362 23.1711 7.2362 17.5C7.2362 11.8289 11.8299 7.23519 17.501 7.23519C23.1721 7.23519 27.7658 11.8289 27.7658 17.5C27.7658 23.1711 23.1721 27.7648 17.501 27.7648Z",
    fill: "url(#paint1_linear_13090_62974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5235 17.6224C13.5235 14.1236 16.3562 11.2909 19.855 11.2909C21.1063 11.2909 22.2706 11.6559 23.2496 12.2815C21.8304 10.7754 19.8145 9.83692 17.5843 9.83692C13.2802 9.83113 9.79297 13.3184 9.79297 17.6224C9.79297 21.9265 13.2802 25.4137 17.5843 25.4137C19.8203 25.4137 21.8304 24.4753 23.2496 22.9692C22.2706 23.5948 21.1063 23.9597 19.855 23.9597C16.362 23.9539 13.5235 21.1155 13.5235 17.6224Z",
    fill: "url(#paint2_linear_13090_62974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4992 7.23474C11.8281 7.23474 7.23438 11.8284 7.23438 17.4996C7.23438 23.1707 11.8281 27.7644 17.4992 27.7644C23.1703 27.7644 27.764 23.1707 27.764 17.4996C27.764 11.8284 23.1703 7.23474 17.4992 7.23474ZM17.5803 25.4125C13.2762 25.4125 9.78899 21.9194 9.78899 17.6212C9.78899 13.3172 13.2762 9.82991 17.5803 9.82991C19.8163 9.82991 21.8264 10.7683 23.2456 12.2745C22.2666 11.6488 21.1023 11.2839 19.8511 11.2839C16.3522 11.2839 13.5195 14.1166 13.5195 17.6154C13.5195 21.1143 16.3522 23.9469 19.8511 23.9469C21.1023 23.9469 22.2666 23.582 23.2456 22.9564C21.8264 24.4683 19.8163 25.4125 17.5803 25.4125ZM20.2508 19.2895L18.287 22.0179L18.2696 18.6523L15.0662 17.627L18.258 16.5727L18.2407 13.2071L20.2334 15.9181L23.4252 14.8638L21.4615 17.5922L23.4542 20.3033L20.2508 19.2895Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13090_62974",
    x1: -8.74382,
    y1: 17.6195,
    x2: 43.7504,
    y2: 17.6195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13090_62974",
    x1: -8.74609,
    y1: 17.4983,
    x2: 43.7482,
    y2: 17.4983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13090_62974",
    x1: -8.74393,
    y1: 17.621,
    x2: 43.7503,
    y2: 17.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTnd);
export default __webpack_public_path__ + "static/media/flagTND.9db9551a923b51b03f27d55e01f4dbe5.svg";
export { ForwardRef as ReactComponent };